import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AlertComponent = ({
  message,
  auto_hide = true,
  timeout = 3000,
  severity,
  close,
  close_args
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShow(false);
    close(...close_args);
  };

  return (
    <Snackbar
      open={show}
      autoHideDuration={timeout}
      onClose={handleClose}
      style={{ width: '320px' }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        <span className={'yekan-font'}>
          {message ? <span>{message}</span> : <span>خطای سرور</span>}
        </span>
      </Alert>
    </Snackbar>
  );
};

const AlertContainer = ({ alerts, close, timeout }) => {
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {alerts?.map((item, index) => (
        <AlertComponent
          key={item.key + index}
          severity={item.severity}
          message={item.message}
          auto_hide={item.auto_hide}
          timeout={timeout}
          close={close}
          close_args={[item.key]}
        />
      ))}
    </Stack>
  );
};

export const useAlert = (timeout = 10000) => {
  const [alert, setAlert] = useState([]);
  const RemoveAlert = (key) => setAlert(alert.filter((i) => i.key !== key));
  const AddAlert = ( { key, message, severity, auto_hide } ) =>
  {
    setAlert([{ key, message, severity, auto_hide }]);
    if (auto_hide)
      setTimeout(() => {
        RemoveAlert(key);
      }, timeout);
  };
  return { alert, AddAlert, RemoveAlert };
};

export default AlertContainer;
